
import './App.css';

function App() {
  return (
    <div className="App">
      welcome to my React app.
      <p>This app is deployed on vercel</p>
    </div>
  );
}

export default App;
